import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import EventList from "/react4xp/components/shared/EventList/EventList";
import Pagination from "/react4xp/components/shared/Pagination/Pagination";
import Tabs from "/react4xp/components/shared/Tabs/Tabs";

import type { EventsPartProps } from "./Events.d";

export const EventsPart = (props: ComponentProps<PartData>) => {
  const {
    showPrevious,
    eventsList,
    background,
    title,
    tabs,
    tabActive,
    linkReadMore,
    totalPage,
    pagination,
    currentPage,
    limitPage,
    urlPage,
  } = (props.data as EventsPartProps) ?? {};

  if (!showPrevious && (!eventsList || eventsList.length === 0)) {
    return null;
  }

  return (
    <section className={background}>
      <div className="container">
        {title && <h2 className="frontpage-section-title">{title}</h2>}

        {showPrevious && <Tabs items={tabs} tabActive={tabActive} />}

        <EventList items={eventsList} />

        {linkReadMore && (
          <div className="read-more-link">
            <a href={linkReadMore}>Se alle arrangementer</a>
          </div>
        )}

        {pagination && totalPage > 0 && (
          <Pagination
            current={currentPage}
            pages={totalPage}
            limit={limitPage}
            pageurl={urlPage}
          />
        )}
      </div>
    </section>
  );
};

export default EventsPart;
